module.exports = __webpack_public_path__ + "img/body-3-lg.ef62c422.png";